import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=3800c962&scoped=true&"
import script from "./agreement.vue?vue&type=script&lang=js&"
export * from "./agreement.vue?vue&type=script&lang=js&"
import style0 from "./agreement.vue?vue&type=style&index=0&id=3800c962&lang=scss&scoped=true&"
import style1 from "./agreement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800c962",
  null
  
)

component.options.__file = "agreement.vue"
export default component.exports